// extracted by mini-css-extract-plugin
module.exports = {"comments":"_2FBHF5","shine-lines":"_3YU-GY"};